import { render } from "./projectdetailssidebar.vue?vue&type=template&id=a677657e"
import script from "./projectdetailssidebar.vue?vue&type=script&lang=js"
export * from "./projectdetailssidebar.vue?vue&type=script&lang=js"

import "./projectdetailssidebar.vue?vue&type=style&index=0&id=a677657e&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__